import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["label"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_13 = {
  key: 1,
  class: "col-12"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { style: {"height":"37px","display":"block","margin-top":"12px"} }
const _hoisted_16 = { class: "text-center mt-3" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Production Process",
          text: "Edit Production Process"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              type: "label",
              localizedKey: "Production Process",
              text: "Production Process"
            }),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.productionProcessIdentifier) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.filteredAllProductionProcesses as any), (value, key, i) => {
                return (_openBlock(), _createElementBlock("optgroup", {
                  key: key,
                  label: key ? key.toString() : 'Single items'
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: item.identifier
                    }, _toDisplayString(item.text), 9, _hoisted_11))
                  }), 128))
                ], 8, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.model.productionProcessIdentifier]
            ])
          ])
        ]),
        (_ctx.isUnitCalculated && _ctx.model.productionProcessIdentifier)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Value",
                labelValue: "Value",
                placeholderKey: "Value",
                placeholderValue: "Value",
                modelValue: _ctx.model.units,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.units) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isElectricityEmissionIndipendent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Production Country",
                    text: "Production Country"
                  })
                ]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.countries.find(x => x.identifier == _ctx.model.productionCountry).text), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Edit",
            text: "Edit"
          })
        ], 8, _hoisted_17)
      ])
    ])
  ]))
}